import React from 'react';

const GetPreparedWall: React.FC = () => {
  return (
    <div>
      <div className="flex justify-center p-10">
        <iframe
          src="https://trello.com/b/SrsgHKzM.html"
          width="1860"
          height="898"
          frameBorder="0"
          title="Get Prepared Wall Trello Board"
        ></iframe>
      </div>
    </div>
  );
};

export default GetPreparedWall;
